import { useCallback, useState, useEffect } from "react";
import type { ComponenteOF } from "@/ts/api/API";
import type { ConsumoOrNot, iConsumo } from "./FormInputar";
import { Constantes } from "@/ts/constantes";
import { formatIDArt } from "@/ts/util";


interface SelectorComponentesProps {
	readonly cantidadFabricada: number;
	readonly componentesOF: ComponenteOF[];

	// readonly consumos: iConsumo[];
	readonly setConsumos: Setter<iConsumo[]>;
}
export function SelectorComponentes(props: SelectorComponentesProps) {
	const { cantidadFabricada, componentesOF, setConsumos } = props;

	const getDisplay = (bool: boolean) => ({ display: bool ? "table-cell" : "none" });
	const onChangeConsumo = useCallback((consumo: ConsumoOrNot) => {
		setConsumos((consumos) => {
			const index = consumos
				// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
				.filter(item => item != null)
				.findIndex(item => item.idArticulo == consumo.idArticulo && item.faseArticulo == consumo.faseArticulo);

			if (consumo.cantidadUsada == null) {
				if (index < 0) {
					console.warn("Intentando borrar un consumo que no existe");
					return consumos;
				}

				const nuevosConsumos = [...consumos];
				nuevosConsumos.splice(index, 1);
				return nuevosConsumos;
			} else if (index >= 0) {//Updating consumo
				const nuevosConsumos = [...consumos];
				nuevosConsumos[index] = consumo;
				return nuevosConsumos;
			} else {
				const nuevosConsumos = [...consumos, consumo];
				return nuevosConsumos;
			}
		});
	}, [setConsumos]);

	return (
		<table className="display dataTable">
			<thead>
				<tr>
					<th>Usar?</th>
					<th>Componente</th>
					<th>Descripción</th>
					<th>Cantidad Usada</th>
					<th style={getDisplay(!Constantes.articulosDesubicados)}>Ubicación</th>
					<th style={getDisplay(Constantes.existenLotes)}>Lote</th>
					<th>Desperdiciado</th>
					<th>Defectuoso</th>
				</tr>
			</thead>
			<tbody>
				{componentesOF.map((componente) => (
					<FilaComponente
						key={`${componente.idArticulo}-${componente.fase}-${cantidadFabricada}`}
						componente={componente}
						cantidadFabricada={cantidadFabricada}
						onChangeConsumo={onChangeConsumo}
					/>
				))}
			</tbody>
		</table>
	);
}

interface FilaComponenteProps { readonly componente: ComponenteOF, readonly cantidadFabricada: number; readonly onChangeConsumo: (consumo: ConsumoOrNot) => void; }
function FilaComponente(props: FilaComponenteProps) {
	const { componente, cantidadFabricada, onChangeConsumo } = props;

	const formatter = new Intl.NumberFormat("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 0 });
	const getDisplay = (bool: boolean) => ({ display: bool ? "table-cell" : "none" });

	const [checked, setChecked] = useState(componente.checked);
	const [inputUbicacion, setInputUbicacion] = useState("Z00Z00");
	const [inputLote, setInputLote] = useState("");
	const [inputDesperdiciado, setInputDesperdiciado] = useState(0);
	const [inputDefectuoso, setInputDefectuoso] = useState(0);

	useEffect(() => {
		let consumo: ConsumoOrNot;
		if (checked) {
			consumo = {
				idArticulo: componente.idArticulo,
				faseArticulo: componente.fase,
				loteArticulo: inputLote,

				idUbicacion: inputUbicacion,

				cantidadUsada: componente.cantidadPorUnidad * cantidadFabricada,
				cantidadDesperdiciada: inputDesperdiciado,
				cantidadDefectuosa: inputDefectuoso,
			};
		} else {
			consumo = {
				idArticulo: componente.idArticulo,
				faseArticulo: componente.fase
			};
		};

		onChangeConsumo(consumo);
	}, [props.cantidadFabricada, checked, inputUbicacion, inputLote, inputDesperdiciado, inputDefectuoso, onChangeConsumo, componente, cantidadFabricada]);

	const colSpan = 3 + (Constantes.articulosDesubicados ? 0 : 1) + (Constantes.existenLotes ? 1 : 0);

	return (
		<tr >
			<td>
				<input type="checkbox" checked={checked} onChange={(event) => { setChecked(event.target.checked); }} style={{ minHeight: "18px", minWidth: "18px" }} />
			</td>
			<td>
				{formatIDArt(componente.idArticulo, componente.fase)}
			</td>
			<td>
				{componente.descripcion}
			</td>
			{checked ? <>
				<td>
					{formatter.format(componente.cantidadPorUnidad * cantidadFabricada)}
				</td>
				<td style={getDisplay(!Constantes.articulosDesubicados)}>
					<input style={{ width: "10ch" }} value={inputUbicacion} onChange={(event) => { setInputUbicacion(event.target.value); }} />
				</td>
				<td style={getDisplay(Constantes.existenLotes)}>
					<input style={{ width: "8ch" }} value={inputLote} onChange={(event) => { setInputLote(event.target.value); }} />
				</td>
				<td>
					<input style={{ width: "8ch" }} value={inputDesperdiciado} onChange={(event) => { setInputDesperdiciado(Number(event.target.value)); }} />
				</td>
				<td>
					<input style={{ width: "8ch" }} value={inputDefectuoso} onChange={(event) => { setInputDefectuoso(Number(event.target.value)); }} />
				</td>
			</> : null}
			{!checked && <td colSpan={colSpan} style={{ textAlign: "center" }}>No usado</td>}

		</tr>
	);
}